import React from 'react';
import { IconProps } from '.';

const SvgChangeBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m7 2.586 5.207 5.207-1.414 1.414L8 6.414V21H6V6.414L3.207 9.207 1.793 7.793 7 2.586ZM18 17.586l2.793-2.793 1.414 1.414L17 21.414l-5.207-5.207 1.414-1.414L16 17.586V3h2v14.586Z'
      />
    </svg>
  );
};

export default SvgChangeBold;
